
































































































































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import {
  teachingRecordStatic,
  classroomList,
  teachingRecordExport,
  teachingRecordInfo
} from '@/api/teachingProtection/teachManage'

@Component({
  name: 'Teach',
  components: {
    Chart
  },
  filters: {
    sensitive(arr:any, sensitiveList:any | []) {
      console.log(sensitiveList)
      let str = ''
      if (arr && arr.length) {
        arr.map((item:any) => {
          let Index = sensitiveList.findIndex((val:any) => item === val.code)
          if (Index > -1) {
            str += '   ' + sensitiveList[Index].description
          }
        })
        return str
      } else {
        return ''
      }
    }
  }
})
export default class extends Vue {
  private staticTime: (string | number)[] = [Date.now(), Date.now()]; // 统计时间
  private recordTime: (string | number)[] = [Date.now(), Date.now()]; // 记录时间
  private staticForm: any = {
    fromTime: Date.now(),
    toTime: Date.now(),
    classroomIds: [],
    teachingCategoryTypes: []

  };
  private recordForm: any = {
    fromTime: Date.now(),
    toTime: Date.now(),
    classroomId: '',
    job: '',
    sport: '',
    studentName: ''
  };
  private dialogForm:any = {
    studentId: '',
    teachingCategoryType: '',
    teachingTime: ''

  }
  private classList:any = [] // 班级
  private sensitiveList:any = this.$enums.sensitiveList
  private series:any = [
    {
      name: '蒙氏工作-已记录',
      type: 'bar',
      stack: '蒙氏',
      data: []
    },
    {
      name: '蒙氏工作-未记录',
      type: 'bar',
      stack: '蒙氏',
      data: []
    },
    {
      name: '运动体能-已记录',
      type: 'bar',
      stack: '运动',
      data: []
    },
    {
      name: '运动体能-未记录',
      type: 'bar',
      stack: '运动',
      data: []
    },
    {
      name: '绘本课程-已记录',
      type: 'bar',
      stack: '绘本',
      data: []
    },
    {
      name: '绘本课程-未记录',
      type: 'bar',
      stack: '绘本',
      data: []
    }
  ]
  private options: any = {
    color: ['#7CB8F8', '#FF8A8A', '#46AE84', '#FFD805', '#BD8DEF', '#70B603'],
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        // 坐标轴指示器，坐标轴触发有效
        type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
      }
    },
    legend: {
      data: ['蒙氏工作-已记录', '蒙氏工作-未记录', '运动体能-已记录', '运动体能-未记录', '绘本课程-已记录', '绘本课程-未记录']
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        name: '班级',
        data: [],
        axisLabel: {
          interval: 0,
          rotate: 40
        }
      }
    ],
    yAxis: [
      {
        type: 'value',
        name: '单位：人'
      }
    ],
    series: []
  };

  /* 弹框 */
  private dialogVisible: boolean = false;
  private dialogTitle: string = '';
  private infoVisible: boolean = false;
  private infoTitle: string = '记录详情';
  private recordInfo:any = {} // 记录详情
  private curRowData:any = {} // 当前学生信息

  @Watch('staticTime', {
    immediate: true,
    deep: true
  })
  onChangeValue(newVal: string[], oldValue: string[]) {
    this.staticForm.fromTime = newVal.length ? newVal[0] : ''
    this.staticForm.toTime = newVal.length ? newVal[1] : ''
  }
  @Watch('recordTime', {
    immediate: true,
    deep: true
  })
  onrecordTimeChangeValue(newVal: string[], oldValue: string[]) {
    this.recordForm.fromTime = newVal.length ? newVal[0] : ''
    this.recordForm.toTime = newVal.length ? newVal[1] : ''
  }

  created() {
    this.getTeachingStatic()
    this.getClassList()
  }
  /**
   * 获取班级
   */
  private async getClassList() {
    const resp = await classroomList({
      page: 1,
      size: 9999
    })
    this.classList = (resp as any).data.array || []
  }
  /**
   * 查看弹框列表
   */
  private async viewRecord(row:any, type:any) {
    this.curRowData = row
    if (type === 101) {
      this.dialogTitle = '蒙氏工作'
    } else if (type === 102) {
      this.dialogTitle = '运动体能'
    } else {
      this.dialogTitle = '绘本课程'
    }
    this.dialogForm = {
      studentId: row.studentId,
      teachingCategoryType: type,
      teachingTime: row.teachingTime
    }
    this.dialogVisible = true
    // let Info = await teachingRecordInfo({ teachingRecordId: row.teachingRecordId })
  }
  /**
   * 查看弹框列表
   */
  private async viewInfo(row:any) {
    // if (type === 101) {
    //   this.dialogTitle = '蒙氏工作'
    // } else if (type === 102) {
    //   this.dialogTitle = '运动体能'
    // } else {
    //   this.dialogTitle = '绘本课程'
    // }
    this.infoVisible = true
    let Info = await teachingRecordInfo({ teachingRecordId: row.teachingRecordId })
    this.recordInfo = Info.data
  }
  /**
   * 导出详细数据
   */
  private async exportRecord() {
    let promise = null
    const resp = await teachingRecordExport({
      ...this.recordForm
    })
    window.location = (resp as any).message
    return promise
  }

  /**
   * 柱状图
   */
  private getTeachingStatic() {
    teachingRecordStatic({
      ...this.staticForm
    })
      .then(res => {
        let arr = res.data.array || []
        if (arr.length === 0) {
          this.options.xAxis[0].data = []
          this.options.series = [];
          (this.$refs.staticChart as any).setOption(this.options)
          return
        }
        let xAxis:any = []
        this.series.map((item:any) => { item.data = [] })
        let series = [...this.series]
        arr.map((item:any, index:any) => {
          xAxis.push(item.classroomName)
          series[0].data.push(item.job.record)
          series[1].data.push(item.job.notRecord)
          series[2].data.push(item.sport.record)
          series[3].data.push(item.sport.notRecord)
          series[4].data.push(item.pictureCourse.record)
          series[5].data.push(item.pictureCourse.notRecord)
        })
        this.options.xAxis[0].data = xAxis
        let teachingCategoryTypes = [...this.staticForm.teachingCategoryTypes]
        if (teachingCategoryTypes.length > 0) {
          if (teachingCategoryTypes.indexOf(101) < 0) {
            series.map((item:any, index:any) => {
              if (item.stack === '蒙氏') {
                series.splice(index, 2)
              }
            })
          }
          if (teachingCategoryTypes.indexOf(102) < 0) {
            series.map((item:any, index:any) => {
              if (item.stack === '运动') {
                series.splice(index, 2)
              }
            })
          }
          if (teachingCategoryTypes.indexOf(103) < 0) {
            series.map((item:any, index:any) => {
              if (item.stack === '绘本') {
                series.splice(index, 2)
              }
            })
          }
        }
        this.options.series = [...series];
        (this.$refs.staticChart as any).setOption(this.options)
      })
      .catch(() => {})
  }
  /**
   * 教学统计
   */
  private staticSearch() {
    this.getTeachingStatic()
  }
  private staticReset() {
    this.staticForm.classroomIds = []
    this.staticForm.teachingCategoryTypes = []
    this.getTeachingStatic()
  }
  /**
   * 记录
   */
  private recordSearch() {
    (this.$refs.table as any).search()
  }
  private recordReset() {
    Object.keys(this.recordForm).forEach(key => {
      this.recordForm[key] = ''
    })
    this.recordForm.fromTime = this.recordTime[0]
    this.recordForm.toTime = this.recordTime[1]
    this.$nextTick(() => {
      (this.$refs.table as any).search()
    })
  }
  /**
   * 记录时间筛选
   */
  private getTeachingRecord() {
    this.recordSearch()
  }
}
